import React from "react";
import { StyledDefaultButton } from "./DefaultButton.style";

type Props = {
  url: string;
  title: string;
};

const DefaultFileButton = ({ url, title }: Props) => {
  return (
    <StyledDefaultButton href={url} target="_blank">
      {title}
    </StyledDefaultButton>
  );
};

export default DefaultFileButton;
